export default __webpack_public_path__ + "static/pulizia-10b490ba0a41a51a2df3909f16586728.png";